import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bmr-calculator',
  component: () => import('../../routes/BmrCalculator.svelte'),
  card: {
    id: 'bmr-calculator',
    title: 'BMR Calculator',
    description: 'Calculate your Basal Metabolic Rate (BMR) using the Katch-McArdle formula with your body fat percentage, plus your Total Daily Energy Expenditure (TDEE).',
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/bmr-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'BMR Calculator — Basal Metabolic Rate & TDEE',
    description: 'Free BMR calculator using the Katch-McArdle formula. Enter your weight and body fat percentage to find your daily calorie burn and TDEE.',
  },
};

export default meta;
